(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers')
        .directive('actionPlanUpdateStatusOwnerCard', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                owner: '=',
                readOnly: '=',
                isMultiSelect: '=',
                toSendReminder: '&',
                recomBusinessUnit: '='
            },
            restrict: 'AE',
            templateUrl: require('./ownerCard.tpl.html'),
            controller: ['$scope', '$state', 'recomActionPlanUpdateStatusService', '$timeout', '$modal', function ($scope, $state, recomActionPlanUpdateStatusService, $timeout, $modal) {

                // Reminder flags
                $scope.sendReminderError = null;
                $scope.sendReminderSuccess = false;
                $scope.sendReminderSuccessTimeout = null;
               
                // Show or hide actions
                $scope.card_onClick = function ($event) {
                    if ($scope.readOnly || $scope.isMultiSelect) return;
                    $scope.showOrHideActions($event);
                    $event.stopPropagation();
                };

                $scope.showOrHideActions = function ($event) {
                    if ($scope.readOnly || $scope.isMultiSelect) return;
                    $scope.displayActions = !$scope.displayActions;
                    $event.stopPropagation();
                };

                // Send reminder to owner
                $scope.sendReminderToOwner = function () {
                    $scope.sendReminderError = null;
                    $scope.sendReminderSuccess = null;

                    if ($scope.sendReminderSuccessTimeout !== null) {
                        $timeout.cancel($scope.sendReminderSuccessTimeout);
                    }
                    $scope.sendReminderSuccessTimeout = null;

                    var buCodes = ['InternalAudit', 'InformationSecurityMandate', 'AssessmentRecommendation', 'DerogationException', 'BTGMandate'];
                    if (buCodes.indexOf($scope.recomBusinessUnit.Code)>=0) {
                        displaySendReminderModal();
                        return;
                    }
                    
                    $scope.owner.isSendingInvitation = true;
                    return recomActionPlanUpdateStatusService
                            .sendReminderToOwner($scope.recomBusinessUnit.RecomBusinessUnitID, $scope.owner)
                            .then(function (updatedOwner) {
                                _.assign($scope.owner, updatedOwner);
                            })
                            .finally(function () {
                                $scope.owner.isSendingInvitation = false;
                                $scope.sendReminderError = null;
                                $scope.sendReminderSuccess = true;

                                // Returns the card after some time to hide the actions
                                $scope.sendReminderSuccessTimeout = $timeout(function () {
                                    $scope.sendReminderSuccess = false;
                                    $scope.displayActions = false;
                                }, 20000);
                            });
                };

                // Show Send Reminder Action
                $scope.showSendReminderAction = function () {
                    var ownerStatusValue = $scope.owner.OwnerStatusValue;

                    if (ownerStatusValue === 'Completed') return false;

                    return true;
                };

                function displaySendReminderModal() {
                    var modalScope = $scope.$new(true);
                    modalScope.owner = $scope.owner;

                    var showModal = $modal({
                        scope: modalScope,
                        template: '/app/Main/recomActionPlanStatusUpdate/ownerSendReminderModal.tpl.html',
                        placement: 'center'
                    });

                    // Hide Modal
                    modalScope.hideModal = function () {
                        showModal.$promise.then(showModal.hide);
                    };

                    // OK Modal
                    modalScope.okModal = function (deadline, recipientsCc) {
                        if ($scope.owner.isSendingInvitation) return;
                        if (!deadline) return;

                        $scope.owner.isSendingInvitation = true;

                        var recomContainerOwnerReminder = {
                            Deadline: deadline,
                            RecipientsCC: recipientsCc
                        };

                        return recomActionPlanUpdateStatusService
                            .sendReminderToOwner($scope.recomBusinessUnit.RecomBusinessUnitID, $scope.owner, recomContainerOwnerReminder)
                            .then(function (updatedOwner) {
                                $scope.sendReminderSuccess = true;
                                _.assign($scope.owner, updatedOwner);
                            }, function () {
                                $scope.sendReminderError = 'Couldn\'t send reminder';
                                $scope.sendReminderSuccess = false;
                            })
                            .finally(function () {
                                if ($scope.sendReminderSuccess) modalScope.hideModal();

                                $scope.owner.isSendingInvitation = false;

                                // Returns the card after some time to hide the actions
                                $scope.sendReminderSuccessTimeout = $timeout(function () {
                                    $scope.sendReminderSuccess = false;
                                    $scope.displayActions = false;
                                }, 20000);
                            });
                    };
                }

            }],
            link: function (scope) {
                //Display or not actions
                scope.displayActions = false;
            }
        };
    }
})();